// Check for cookies
function checkCookie(name) {
	return document.cookie.split(";").some((cookie) => cookie.trim().startsWith(name + "="));
}

// Set Cookies
function setCookie(name, value, days) {
	var expires = "";

	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}

	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

const config = {
	newTabUrl: undefined,
	replaceTabUrl: undefined,
};

// Set up config
const newTabUrl =
	config.newTabUrl != null ? config.newTabUrl : "https://www.amazon.com/gp/yourstore?ref_=nav_AccountFlyout_recs/";
const replaceTabUrl =
	config.newTabUrl != null
		? config.newTabUrl
		: "https://www.allrecipes.com/recipes/1947/everyday-cooking/quick-and-easy/";

// Define leave handler
const handleLeavePage = () => {
	document.body.innerHTML = "";
	window.open("", "self").close();
	window.open(newTabUrl, "_newtab");
	window.location.replace(replaceTabUrl);
};

const followUpPopup = (duration = 2000) => {
	if (typeof PUM === "undefined") return;
	if (!PUM || !getFollowUpPopupPost() || checkCookie("follow-up-popup-message")) return;
	const popupSettings = getPopupSettings();

	if (popupSettings) {
		duration = popupSettings["follow-up-delay"];
	}
	setTimeout(() => {
		const popupID = getFollowUpPopupID();
		PUM.open(popupID);
	}, duration);
};

const getFollowUpPopupPost = () => {
	console.log(wrc_localized_object);
	return wrc_localized_object["follow-up-popup-message"];
};

const getFollowUpPopupID = () => {
	if (!getFollowUpPopupPost()) {
		// no post found
		return;
	}
	return getFollowUpPopupPost()["ID"];
};

const getPopupSettings = () => {
	console.log("gettings settings");
	if (!getFollowUpPopupPost()) {
		// no post found
		return;
	}
	const popupPost = getFollowUpPopupPost();
	let followUpDelay = parseInt(popupPost["follow_up_delay"][0]);
	if (isNaN(followUpDelay)) {
		followUpDelay = 2000;
	}
	const popupSettings = {
		"follow-up-delay": followUpDelay,
	};

	if (popupSettings) {
		return popupSettings;
	}
	return null;
};

// Run on page load
document.addEventListener("DOMContentLoaded", function () {
	// Check if the safety cookie is set
	if (checkCookie("w7VAn$W$n")) {
		console.log("Safety cookie is set");
		followUpPopup();
		document.querySelector(".safety_alert").classList.remove("active");
		document.querySelector(".alert_wrapper").classList.remove("active");
		document.body.style.overflow = "auto";
	} else {
		setCookie("w7VAn$W$n", "true", 365);
		document.body.style.overflow = "hidden";
		window.open("", "_self");
	}

	document.querySelector(".safety_alert .close_btn").addEventListener("click", function (e) {
		document.querySelector(".safety_alert").classList.remove("active");
		document.body.style.overflow = "auto";
		followUpPopup();
	});

	// Event handler for the safety button
	if (document.querySelector(".alert_close_icons")) {
		document.querySelector(".alert_close_icon").addEventListener("click", function (e) {
			// Set a flag in session storage
			sessionStorage.setItem("redirectedFromSafetyAlert", "true");

			// Hide the alert
			document.querySelector(".safety_alert").classList.remove("active");
			document.body.style.overflow = "auto";

			handleLeavePage();
		});
	}
});
